/*global google */

define('views/pages/wishlist/wishes/modal/content',['require','jquery','underscore','lib/utils','views/base/form','text!templates/pages/wishlist/wishes/modal/content.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        utils = require('lib/utils'),
        FormView = require('views/base/form'),
        template = require('text!templates/pages/wishlist/wishes/modal/content.ejs');

        // require('select2');

    function debug() {
        // console.log.apply(console, arguments);
    }

    var WishlistItemModalContentView = FormView.extend({
        autoRender: true,
        className: 'wishlist-modal-content form-horizontal',
        region: 'modal-content',
        template: template,
        customValidation: true,
        events: {
            'change input[name=countryId]':        'changedAttribute',
            'change input[name=goodsCategoryId]':  'changedAttribute',
            'change input[name=goodsTypeId]':      'changedAttribute',
            'change input[name=goods]':            'changedAttribute',
            'change input[name=currencyId]':       'changedAttribute',
            'change input[name=lengths]':          'changedAttribute',
            'change input[name=sellers]':          'changedAttribute',
            'change input[name=vendors]':          'changedAttribute',
            'change input[name=vendorCountries]':  'changedAttribute',
            'change select[name=freshness]':       'changedAttribute',
            'change select[name=quality]':         'changedAttribute'
        },
        listen: {
            'loaded model':                  'loaded',
            'change:countryId model':        'changedCountryId',
            'change:goodsCategoryId model':  'changedGoodsCategoryId',
            'change:goodsTypeId model':      'changedGoodsTypeId',
            'change:favoriteGoods model':    'changedFavoriteGoods',
            'change:favoriteSellers model':  'changedFavoriteSellers',
            'change:onlyToday model':        'changedOnlyToday',

            'wishlist.save mediator':        'submit'
        },
        initialize: function() {
            FormView.prototype.initialize.apply(this, arguments);

            this.on('addedToDOM', this.onAddedToDOM);

            var evt = 'sync reset';
            var model = this.model;

            this.listenTo(model.countryId,       evt,  this.setCountryId);
            this.listenTo(model.goodsCategoryId, evt,  this.setGoodsCategoryId);
            this.listenTo(model.goodsTypeId,     evt,  this.setGoodsTypeId);
            this.listenTo(model.goods,           evt,  this.setGoods);
            this.listenTo(model.lengths,         evt,  this.setLengths);
            this.listenTo(model.currencyId,      evt,  this.setCurrencyId);
            this.listenTo(model.sellers,         evt,  this.setSellers);
            this.listenTo(model.vendors,         evt,  this.setVendors);
            this.listenTo(model.vendorCountries, evt,  this.setVendorCountries);
        },
        loaded: function() {
            this.onAddedToDOM();
        },
        render: function() {
            FormView.prototype.render.apply(this, arguments);
        },

        setData: function(fieldName, multiple) {
            var items = this.model[fieldName].toJSON();

            if (items && items.length === 1) {
                var setObject = {};
                setObject[fieldName] = items[0].id;
                this.model.set(setObject, { silent: false });
            }

            var value = this.model.get(fieldName);

            debug('+', fieldName, '+', items, '<=', value);

            var $el = this.$('input[name=' + fieldName + ']');

            $el
                .select2({ data: items, multiple: multiple })
                .val(value)
                .select2('val', value);

        },

        setActive: function() {
            if (this.model.get('active')) {
                this.$('input[name=active]').prop('checked', 'checked');
            }
        },
        setCountryId: function() {
            this.setData('countryId');
        },
        setGoodsCategoryId: function() {
            this.setData('goodsCategoryId');
        },
        setGoodsTypeId: function() {
            this.setData('goodsTypeId');
        },
        setGoods: function() {
            this.setData('goods', true);
        },
        setLengths: function() {
            this.setData('lengths', true);
        },
        setVendors: function() {
            this.setData('vendors', true);
        },
        setCurrencyId: function() {
            this.setData('currencyId');
        },
        setSellers: function() {
            this.setData('sellers', true);
        },
        setVendorCountries: function() {
            this.setData('vendorCountries', true);
        },

        changedCountryId: function(model) {
            debug('changedCountryId');

            if (parseInt(model.get('countryId'), 10) === model.previous('countryId')) { return; }

            model.loadCountryIdDeps(true);
        },
        changedGoodsCategoryId: function(model) {
            debug('changedGoodsCategoryId');

            if (parseInt(model.get('goodsCategoryId'), 10) === model.previous('goodsCategoryId')) { return; }

            model.loadGoodsCategoryIdDeps(true);
        },
        changedGoodsTypeId: function(model) {
            debug('changedGoodsTypeId');

            if (parseInt(model.get('goodsTypeId'), 10) === model.previous('goodsTypeId')) { return; }

            model.loadGoodsTypeIdDeps(true);
        },
        changedFavoriteGoods: function(model) {
            debug('changedFavoriteGoods');

            var $goods =this.$('input[name=goods]');

            if (model.get('favoriteGoods')) {
                $goods.val('').trigger('change');
            }

            $goods.prop('disabled', model.get('favoriteGoods'));
            $goods.prop('placeholder', model.get('favoriteGoods') ? 'Избранные' : 'Все').trigger('change');
        },
        changedFavoriteSellers: function(model) {
            debug('changedFavoriteSellers');

            var $sellers =this.$('input[name=sellers]');

            if (model.get('favoriteSellers')) {
                $sellers.val('').trigger('change');
            }

            $sellers.prop('disabled', model.get('favoriteSellers'));
            $sellers.prop('placeholder', model.get('favoriteSellers') ? 'Избранные' : 'Все').trigger('change');
        },
        changedOnlyToday: function(model) {
            var value;

            debug('changedOnlyToday');

            var $onlyToday = this.$('input[name=activeUntil]');

            if (model.get('onlyToday')) {
                model.set('activeUntilOld', model.get('activeUntil'));

                value = new Date();
                value.setDate(value.getDate() + 1);
                $onlyToday.datepicker('setValue', value);
            } else {
                value = model.get('activeUntilOld');
                if (value) {
                    $onlyToday.datepicker('setValue', value);
                }
            }

            $onlyToday.prop('disabled', model.get('onlyToday'));
        },

        onAddedToDOM: function() {
            var model = this.model;

            debug('onAddedToDOM >>>');

            this.setActive();
            this.setCountryId();
            this.setCountryId();
            this.setGoodsCategoryId();
            this.setGoodsTypeId();
            this.setGoods();
            this.setLengths();
            this.setCurrencyId();
            this.setSellers();
            this.setVendors();
            this.setVendorCountries();

            this.$('input[name=minLot]').val(model.get('minLot'));
            this.$('input[name=price]').val(model.get('price'));

            if (model.get('favoriteGoods')) {
                this.$('input[name=favoriteGoods]').prop('checked', 'checked');
                this.changedFavoriteGoods(model);
            }

            if (model.get('favoriteSellers')) {
                this.$('input[name=favoriteSellers]').prop('checked', 'checked');
                this.changedFavoriteSellers(model);
            }

            this.$('select[name=freshness]').select2();
            this.$('select[name=freshness]').val(this.model.get('freshness')).trigger('change');
            this.$('select[name=quality]').select2();
            this.$('select[name=quality]').val(this.model.get('quality')).trigger('change');

            this.$('input[name=activeUntil]')
                .on('keypress', function(e){
                    return e.metaKey || e.which <= 0 || e.which === 8;
                })
                .datepicker({
                    format: 'dd.mm.yyyy',
                    weekStart: 1
                })
                .datepicker('setValue', this.model.get('activeUntil'));


            this.$('[data-toggle=tooltip]').tooltip({ container: 'body' });

            this.$('.nav-tabs a').click(function (e) {
                e.preventDefault();
                $(this).tab('show');
            });

            debug('<<ADDED');

        },

        save: function() {
            var _this = this;

            debug('       !!! saving');

            this.model.set('activeUntil', this.$('input[name=activeUntil]').data('datepicker').date);

            this.model.save(null, { silent: true })
                .always(function() {
                })
                .success(function() {
                    _this.publishEvent('wishlist.saved');
                });
        },

        showLoader: function() {
            this.publishEvent('wishlist.showPreloader');
        },

        hideLoader: function() {
            this.publishEvent('wishlist.hidePreloader');
        }
    });

    return WishlistItemModalContentView;
});

